module.exports = __webpack_public_path__ + "static/media/whiteBorderHP.fa1b7771.svg";